import React, { useState, useEffect } from 'react';
import { View, TextInput } from 'react-native';
import styles from './style';
import { Text } from '@/components/Text';
import { Button } from '@/components/ui/therapist/Button';

type PaginationProps = {
  currentPage: number;
  totalPages: number;
  onPageChange: (newPage: number) => void;
};

export const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
}) => {
  const [inputValue, setInputValue] = useState(currentPage.toString());

  useEffect(() => {
    setInputValue(currentPage.toString());
  }, [currentPage]);

  const goToPreviousPage = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const goToNextPage = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const handlePageInputChange = (text: string) => {
    const numericText = text.replace(/[^0-9]/g, '');
    setInputValue(numericText);
  };

  const handlePageInputBlur = () => {
    const parsed = parseInt(inputValue, 10);
    if (!isNaN(parsed) && parsed >= 1 && parsed <= totalPages) {
      if (parsed !== currentPage) {
        onPageChange(parsed);
      }
    } else {
      setInputValue(currentPage.toString());
    }
  };

  return (
    <View style={styles.container}>
      <Button
        onPress={goToPreviousPage}
        disabled={currentPage === 1}
        look="ghost"
        icon="chevronLeft"
      />
      <View style={styles.paginationInfo}>
        <Text style={styles.labelText}>Seite</Text>
        <View style={styles.inputContainer}>
          <TextInput
            value={inputValue}
            onChangeText={handlePageInputChange}
            onBlur={handlePageInputBlur}
            keyboardType="number-pad"
            maxLength={totalPages.toString().length}
            style={styles.pageInput}
          />
        </View>
        <Text style={[styles.labelText]}>von {totalPages}</Text>
      </View>
      <Button
        onPress={goToNextPage}
        disabled={currentPage === totalPages}
        look="ghost"
        icon="chevronRight"
      />
    </View>
  );
};
